import Vue from 'vue'
import App from '@/App.vue'

import '@/plugins/ClickOutside'
import '@/plugins/Prototype'
import '@/plugins/VeeValidate'
import '@/plugins/Filter'

import '@/assets/css/tailwind.css'

Vue.config.productionTip = false

new Vue({
  render: (h) => h(App)
}).$mount('#app')
